module.exports = __webpack_public_path__ + "media/images/application/alerts/lanceur-8ca0fa4fbba3917704d2c8205dccaac8.svg";